import { render, staticRenderFns } from "./KeyValuesList.vue?vue&type=template&id=1bce7ffb"
import script from "./KeyValuesList.vue?vue&type=script&lang=js"
export * from "./KeyValuesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports